import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Form, Row, Col, Modal, Button } from "react-bootstrap";
import {
  getCapitulosTomo1,
  getSubcapitulosByCapituloId,
  getApartadosBySubcapituloId,
  getSubapartadosByApartadoId,
  getSubapartadosBySubcapituloId,
  getSubapartadosByCapituloId,
} from "../../services/sumarioService";
import { INFO } from "../iconsSVG/IconsSVG";

const CombosAnidados = forwardRef(({ combosAnidadosT1 }, ref) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [capitulos, setCapitulos] = useState([]);

  const [subcapitulos, setSubcapitulos] = useState([]);
  const [apartados, setApartados] = useState([]);
  const [subapartados, setSubapartados] = useState([]);

  const [selectedCapituloId, setSelectedCapituloId] = useState("");
  const [selectedSubcapituloId, setSelectedSubcapituloId] = useState("");
  const [selectedApartadoId, setSelectedApartadoId] = useState("");
  const [selectedSubapartadoId, setSelectedSubapartadoId] = useState("");


  useEffect(() => {
    const fetchCapitulos = async () => {
      const capituloList = await getCapitulosTomo1();
      const arrayTransformado = capituloList.map(item => {
        const [id, displayName] = Object.entries(item)[0];
        return { id: parseInt(id, 10), displayName }; // Devuelves el objeto transformado
      });
      setCapitulos(arrayTransformado);
      setSelectedCapituloId("");
      setSelectedSubcapituloId("");
      setSelectedApartadoId("");
      setSelectedSubapartadoId("");
      setSubcapitulos([]);
      setApartados([]);
      setSubapartados([]);
    };
    fetchCapitulos();
  }, []);


  useEffect(() => {
    combosAnidadosT1(selectedCapituloId,selectedSubcapituloId,selectedApartadoId,selectedSubapartadoId);
    const fetchSubcapitulos = async () => {
      const subcapituloList = await getSubcapitulosByCapituloId(
        selectedCapituloId
      );
      const arrayTransformado = Object.entries(subcapituloList || {}).map(([id, displayName]) => ({
        id: parseInt(id, 10), // Aseguramos que el ID sea un número
        displayName,
      }));
      setSubcapitulos(arrayTransformado);
      setSelectedApartadoId("");
      setSelectedSubapartadoId("");
      setApartados([]);
      setSubapartados([]);
      
      const subapartadoList = await getSubapartadosByCapituloId(
        selectedCapituloId
      );
      const arrayTransform = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
        id: parseInt(id, 10), // Aseguramos que el ID sea un número
        displayName,
      }));
      setSubapartados(arrayTransform);
    };
    fetchSubcapitulos();
  }, [selectedCapituloId]);

  useEffect(() => {
    combosAnidadosT1(selectedCapituloId,selectedSubcapituloId,selectedApartadoId,selectedSubapartadoId);
    const fetchApartados = async () => {
      if (selectedSubcapituloId) {
        const apartadoList = await getApartadosBySubcapituloId(
          selectedSubcapituloId
        );
        if(Object.keys(apartadoList || {}).length > 0){
          const arrayTransformado = Object.entries(apartadoList || {}).map(([id, displayName]) => ({
            id: parseInt(id, 10), // Aseguramos que el ID sea un número
            displayName,
          }));
          setApartados(arrayTransformado);
          setSelectedSubapartadoId("");
          setSubapartados([]);

          const subapartadoList = await getSubapartadosBySubcapituloId(
            selectedSubcapituloId
          );
          const arrayTransform = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
            id: parseInt(id, 10), // Aseguramos que el ID sea un número
            displayName,
          }));
          setSubapartados(arrayTransform);
          setSelectedSubapartadoId("");
        } else{
          const subapartadoList = await getSubapartadosBySubcapituloId(
            selectedSubcapituloId
          );
          const arrayTransformado = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
            id: parseInt(id, 10), // Aseguramos que el ID sea un número
            displayName,
          }));
          setSubapartados(arrayTransformado);
          
        }
      } else {
        setApartados([]);
        setSelectedApartadoId("");
        setSubapartados([]);
        setSelectedSubapartadoId("");
        const subapartadoList = await getSubapartadosByCapituloId(
          selectedCapituloId
        );
        const arrayTransform = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
          id: parseInt(id, 10), // Aseguramos que el ID sea un número
          displayName,
        }));
        setSubapartados(arrayTransform);
      }
      
    };
    fetchApartados();
  }, [selectedSubcapituloId]);

  useEffect(() => {
    combosAnidadosT1(selectedCapituloId,selectedSubcapituloId,selectedApartadoId,selectedSubapartadoId);
    if (selectedApartadoId) {
    const fetchSubapartados = async () => {
      const subapartadoList = await getSubapartadosByApartadoId(
        selectedCapituloId,
        selectedSubcapituloId,
        selectedApartadoId
      );
      const arrayTransformado = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
        id: parseInt(id, 10), // Aseguramos que el ID sea un número
        displayName,
      }));
      setSubapartados(arrayTransformado);
    };
    fetchSubapartados();
  } else {
    if (selectedSubcapituloId) {
      const fetchSubapartados = async () => {
          const subapartadoList = await getSubapartadosBySubcapituloId(
            selectedSubcapituloId
          );
          if(Object.keys(subapartadoList || {}).length > 0){
            const arrayTransformado = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
              id: parseInt(id, 10), // Aseguramos que el ID sea un número
              displayName,
            }));
            setSubapartados(arrayTransformado);
          }else{
            if (selectedCapituloId) {
              const subapartadoList = await getSubapartadosByCapituloId(
                selectedCapituloId
              );
              const arrayTransform = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
                id: parseInt(id, 10), // Aseguramos que el ID sea un número
                displayName,
              }));
              setSubapartados(arrayTransform);
            }
          }
          
        };
        fetchSubapartados();
    }else if (selectedCapituloId) {
        const fetchSubapartados = async () => {
        const subapartadoList = await getSubapartadosByCapituloId(
          selectedCapituloId
        );
        const arrayTransform = Object.entries(subapartadoList || {}).map(([id, displayName]) => ({
          id: parseInt(id, 10), // Aseguramos que el ID sea un número
          displayName,
        }));
        setSubapartados(arrayTransform);
      };
      fetchSubapartados();

  }
}}, [selectedApartadoId]);

useEffect(() => {
  combosAnidadosT1(selectedCapituloId,selectedSubcapituloId,selectedApartadoId,selectedSubapartadoId);
}, [selectedSubapartadoId]);

  useImperativeHandle(ref, () => ({
    resetCapituloId: () => setSelectedCapituloId(""),
    resetSubcapituloId: () => setSelectedSubcapituloId(""),
    resetApartadoId: () => setSelectedApartadoId(""),
    resetSubapartadoId: () => setSelectedSubapartadoId("")
  }));

  return (
    <>
      <strong>Sumario (tipo de publicación) TOMO 1</strong>    
      <Form className="m-0 mt-2 p-0 ps-3 border rounded">
        <p className="m-0 mb-1 p-0 d-flex">
          {/* {" "} */}
          
          <Button className="fondo-blanco-icono" onClick={handleShow}>
            {/* <INFO color_icono="#203C77" color_fondo="white" class="p-0 m-0"/> */}
          </Button>
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>Búsqueda a partir de Capítulo, Subcapítulo, Apartado, Subapartado.</Modal.Body>
          </Modal>
        </p>
        <Row className="mb-2">
          <Col md={4}>
            <Form.Group controlId="formCapitulos">
              <Form.Label style={{ fontSize: '.85em' }}>Capítulo</Form.Label>
              <Form.Select
                className="mb-2"  
                // as="select"
                value={selectedCapituloId}
                onChange={(e) => setSelectedCapituloId(e.target.value)}
              >
                {/* <option value="">Seleccione un capítulo</option> */}
                <option value="">-</option>
                {capitulos.map((capitulo) => (
                  <option key={capitulo.id} value={capitulo.id}>
                    {capitulo.displayName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={4} className={subcapitulos.length > 0 ? "" : "d-none"}>
            <Form.Group controlId="formSubcapitulos">
              <Form.Label style={{ fontSize: '.85em' }}>Subcapítulo</Form.Label>
              <Form.Select
                // as="select"
                value={selectedSubcapituloId}
                onChange={(e) => setSelectedSubcapituloId(e.target.value)}
                disabled={!subcapitulos}
              >
                {/* <option value="">Seleccione un subcapitulo</option> */}
                <option value="">-</option>
                {subcapitulos.map((subcapitulo) => (
                  <option key={subcapitulo.id} value={subcapitulo.id}>
                    {subcapitulo.displayName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col md={4} className={apartados.length > 0 ? "" : "d-none"}>
            <Form.Group controlId="formApartados">
              <Form.Label style={{ fontSize: '.85em' }}>Apartado</Form.Label>
              <Form.Select
                className="mb-2"
                // as="select"
                value={selectedApartadoId}
                onChange={(e) => setSelectedApartadoId(e.target.value)}
                disabled={!apartados}
              >
                {/* <option value="">Seleccione un apartado</option> */}
                <option value="">-</option>
                {apartados.map((apartado) => (
                  <option key={apartado.id} value={apartado.id}>
                    {apartado.displayName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={4} className={subapartados.length > 0 ? "" : "d-none"}>
            <Form.Group controlId="formSubapartados">
              <Form.Label style={{ fontSize: '.85em' }}>Subapartado</Form.Label>
              <Form.Select
                // as="select"
                value={selectedSubapartadoId}
                onChange={(e) => setSelectedSubapartadoId(e.target.value)}
                disabled={!subapartados}
              >
                {/* <option value="">Seleccione un subapartado</option> */}
                <option value="">-</option>
                {subapartados.map((subapartado) => (
                  <option key={subapartado.id} value={subapartado.id}>
                    {subapartado.displayName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>          
        </Row>
        <br />
      </Form>
    </>
  );
});

export default CombosAnidados;
